import type { ReactElement, CSSProperties } from 'react';
import classNames from 'classnames';

import Skeleton from '../../../Skeleton/Skeleton';
import { CARD_SHAPES, CARD_WIDTH_MAP, ICON_HEIGHT_MAP } from '../../constants';
import type { WidgetConfig } from '../../types';

import styles from './Skeleton.module.css';

interface Props {
  config: WidgetConfig;
  className?: string;
}

const SliderNavigationSkeleton = ({
  className,
  config,
}: Props): ReactElement => {
  const cardShape = config?.itemCardShape || CARD_SHAPES.circle;

  return (
    <div
      className={classNames(
        styles.slider,
        {
          [styles.circle]: cardShape === CARD_SHAPES.circle,
          [styles.square]: cardShape === CARD_SHAPES.square,
          [styles.smallSquare]: cardShape === CARD_SHAPES.smallSquare,
          [styles.rectangle]: cardShape === CARD_SHAPES.rectangle,
          [styles.centered]: config.itemsCentered,
        },
        className
      )}
      style={
        {
          '--slider-nav-border-radius': config?.borderRadius,
          '--slide-width': `${CARD_WIDTH_MAP[cardShape]}px`,
          '--icon-height': `${ICON_HEIGHT_MAP[cardShape]}px`,
        } as CSSProperties
      }
    >
      {Array.from({ length: 8 }).map((_v, i) => (
        <div key={i} className={styles.slide}>
          <Skeleton className={styles.iconContainer} />
          <Skeleton className={styles.text} />
        </div>
      ))}
    </div>
  );
};

export default SliderNavigationSkeleton;
